var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.47,0h81.58a19.79,19.79,0,0,1,14,5.82l.32.35a19.79,19.79,0,0,1,5.5,13.66v83.22a19.91,19.91,0,0,1-19.83,19.83H19.83A19.91,19.91,0,0,1,0,103.05V21.47A21.56,21.56,0,0,1,21.47,0ZM39.69,89.08V33.8H68.34c5.31,0,9.09,1,11.37,3.1s3.4,5.07,3.4,9-.72,7-2.17,9.15a9.91,9.91,0,0,1-5.79,4.21v.53q10.69,1.84,10.7,14.58,0,6.64-3.54,10.66t-10.88,4Zm24.58-22.5h-6.9V77h6.81c2.48,0,3.71-2.46,3.71-5.46s-1.21-5-3.62-5ZM63,45H57.37v9.67h5.49c2.24,0,3.36-1.84,3.36-4.59S65.11,45,63,45Zm40.1-34.84H21.47A11.37,11.37,0,0,0,10.11,21.47v81.58a9.77,9.77,0,0,0,9.72,9.72h83.22a9.73,9.73,0,0,0,9.72-9.72V19.83a9.73,9.73,0,0,0-2.62-6.64l-.24-.22a9.69,9.69,0,0,0-6.86-2.86Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBIcon);
export default __webpack_public_path__ + "static/media/bIcon.4ca985a4.svg";
export { ForwardRef as ReactComponent };